import { STACK } from '../constants/featureFlags';

// localStorage key for the DebugMenu "Redirect launches to localhost" toggle.
// Deliberately not a URL param so it can never leak into restartSession URLs,
// saved links, or exported logs — it is per-browser, per-origin state.
export const REDIRECT_FLAG_KEY = 'debugRedirectToLocalhost';

// ponytail: hardcoded webpack dev-server default; make it an editable DebugMenu field if anyone runs a different port
const LOCAL_ORIGIN = 'http://localhost:8080';

/**
 * Returns the localhost URL to redirect this page load to, or null.
 *
 * Automates the README "Testing Locally with Dev Environment" flow: activity
 * launches are full page loads carrying a `token` JWT in the query string,
 * which authenticates from any origin. When the DebugMenu toggle is enabled,
 * token-bearing launches on DEV/STAGE hosts are replayed against localhost
 * before the app consumes the token or strips the query string.
 *
 * Only fires when ALL hold:
 *  - not already on localhost
 *  - stack is DEV or STAGE (dead on PROD builds even if the flag is set)
 *  - the DebugMenu toggle is enabled in localStorage
 *  - the URL carries a `token` param (i.e. it would authenticate on localhost)
 */
/**
 * True when the app is being served from the local dev server.
 * @returns {boolean}
 */
export function isRunningLocally(location = window.location) {
  return ['localhost', '127.0.0.1'].includes(location.hostname);
}

export function getLocalhostRedirectUrl(
  location = window.location,
  storage = window.localStorage,
  stack = process.env.FEATURE_FLAGS_STACK
) {
  if (isRunningLocally(location)) return null;
  if (stack !== STACK.DEV && stack !== STACK.STAGE) return null;

  let enabled = false;
  try {
    enabled = storage.getItem(REDIRECT_FLAG_KEY) === 'true';
  } catch (err) {
    // Storage unavailable (privacy mode / managed device) — never redirect.
    return null;
  }
  if (!enabled) return null;

  if (!new URLSearchParams(location.search).has('token')) return null;

  return `${LOCAL_ORIGIN}${location.pathname}${location.search}`;
}
